// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ScanQrCode-module-scanQrContainer-\\+dW7b{display:block}@media(min-width: 960px){.ScanQrCode-module-scanQrContainer-\\+dW7b{display:none}}.ScanQrCode-module-scanQrButton-rA0Ax{position:relative;width:100%}.ScanQrCode-module-scanQrIcon-68XqP{position:absolute;color:#fff;inset-inline-start:10%;top:50%;transform:translate(-50%, -50%)}[dir=rtl] .ScanQrCode-module-scanQrIcon-68XqP{transform:translate(50%, -50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scanQrContainer": "ScanQrCode-module-scanQrContainer-+dW7b",
	"scanQrButton": "ScanQrCode-module-scanQrButton-rA0Ax",
	"scanQrIcon": "ScanQrCode-module-scanQrIcon-68XqP"
};
export default ___CSS_LOADER_EXPORT___;
